<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <InformacionGeneralEvaluacionSection :evaluacion="evaluacion" />
      </v-col>
      <v-col cols="12">
        <ReactivosEvaluacionSection :evaluacion="evaluacion" :reactivos="reactivos" />
      </v-col>
      <v-col cols="12">
        <ResultadoEvaluacionSection :evaluacion="evaluacion" />
      </v-col>
      <v-col cols="12">
        <v-btn color="secondary" @click="updateEvaluacion()" :loading="loading">Guardar evaluación</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UpdateRespetoValoresPrincipios from '@/modules/respeto-valores-principios/application/UpdateRespetoValoresPrincipios.usecase'
import { mapGetters, mapMutations } from 'vuex'
import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '../../../../modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import InformacionGeneralEvaluacionSection from '../sections/InformacionGeneralEvaluacionSection.vue'
import ReactivosEvaluacionSection from '../sections/ReactivosEvaluacionSection.vue'
import ResultadoEvaluacionSection from '../sections/ResultadoEvaluacionSection.vue'
import RespetoValoresPrincipiosApiRepository from '@/modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'
import {
  getCalification,
  getIdResultado,
  getPuntajeTotal,
} from '@/modules/evaluacion-desempeño-academico/domain/rules/evaluation.rules'
import RendimientoProfesionalismoApiRepository from '@/modules/rendimiento-profesionalismo/infrastructure/RendimientoProfesionalismoApi.repository'
import UpdateRendimientoProfesionalismo from '@/modules/rendimiento-profesionalismo/application/UpdateRendimientoProfesionalismo.usecase'
import DesempeñoInstitucionalApiRepository from '@/modules/desempeño-institucional/infrastructure/DesempeñoInstitucionalApi.repository'
import UpdateDesempeñoInstitucional from '@/modules/desempeño-institucional/application/UpdateDesempeñoInstitucional.usecase'

export default {
  components: {
    InformacionGeneralEvaluacionSection,
    ReactivosEvaluacionSection,
    ResultadoEvaluacionSection,
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters('evaluacionesPersonal', {
      evaluacion: 'getSelectedEvaluation',
    }),

    ...mapGetters('reactivoValor', {
      catalogoReactivos: 'getReactivoValor',
    }),

    ...mapGetters('reactivosEvaluacion', {
      reactivosRendimientoProfesionalismo: 'getReactivosRendimientoProfesionalismo',
      reactivosDesempenioInstitucional: 'getReactivosDesempenioInstitucional',
    }),

    reactivos() {
      switch (this.evaluacion.tipo) {
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.RESPECT_VALUES_AND_PRINCIPLES:
          return this.catalogoReactivos
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.PERFORMANCE_AND_PROFESSIONALISM:
          return this.reactivosRendimientoProfesionalismo
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.INSTITUTIONAL_PERFORMANCE:
          return this.reactivosDesempenioInstitucional
        default:
          return []
      }
    },

    getPuntajeTotal: function () {
      return getPuntajeTotal(this.evaluacion.reactivos)
    },

    getCalificacion: function () {
      return getCalification(this.getPuntajeTotal, this.evaluacion.tipo)
    },

    getResultado: function () {
      return getIdResultado(this.getPuntajeTotal, this.evaluacion.tipo)
    },
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),

    async updateEvaluacion() {
      try {
        this.loading = true

        this.evaluacion.puntajeTotal = this.getPuntajeTotal
        this.evaluacion.calificacion = this.getCalificacion
        this.evaluacion.idResultado = this.getResultado

        switch (this.evaluacion.tipo) {
          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.RESPECT_VALUES_AND_PRINCIPLES:
            await new UpdateRespetoValoresPrincipios(new RespetoValoresPrincipiosApiRepository()).execute(
              this.evaluacion
            )
            break

          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.PERFORMANCE_AND_PROFESSIONALISM:
            await new UpdateRendimientoProfesionalismo(new RendimientoProfesionalismoApiRepository()).execute(
              this.evaluacion
            )
            break

          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.INSTITUTIONAL_PERFORMANCE:
            await new UpdateDesempeñoInstitucional(new DesempeñoInstitucionalApiRepository()).execute(this.evaluacion)
            break

          default:
            break
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      this.CLOSE_DIALOG()
    },
  },
}
</script>
